function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('./../../lib/templates/modtemplate');
var RegisterUsernameOverlay = require('./lib/register-username');
var PeerService = require('saito-js/lib/peer_service')["default"];
var AppSettings = require('./lib/registry-settings');
var Registry = /*#__PURE__*/function (_ModTemplate) {
  function Registry(app) {
    var _this;
    _classCallCheck(this, Registry);
    _this = _callSuper(this, Registry, [app]);
    _this.app = app;
    _this.name = 'Registry';
    _this.slug = 'registry';
    _this.description = 'Saito DNS support';
    _this.categories = 'Core Utilities Messaging';
    _this["class"] = 'utility';
    _this.status = 'prod';
    //
    // master DNS publickey for this module
    //
    //this.registry_publickey = 'zYCCXRZt2DyPD9UmxRfwFgLTNAqCd5VE8RuNneg4aNMK';
    _this.registry_publickey = 'sFQuGQ6teVaHs6AAtBBWeDwtGMCGCPNyhTJqYDXCvvVK';

    //
    // peers
    //
    _this.peers = [];

    //
    // we keep an in-memory list of cached keys to avoid the need for contant
    // database lookups. this is used primarily by browsers but also by servers
    // to avoid the need for database hits on simple DNS queries.
    //
    // this set of cached keys is updated by the browser in fetchManyIdentifiers()
    // after it gets a response from the server. It is updated by the server in
    // handlePeerTransaction() when it fields a request from the browser.
    //
    // servers will periodically remove content
    //
    _this.cached_keys = {};
    _this.keys_to_look_up = [];

    //
    // we keep a copy of our own publicKey for convenience. this is set in
    // super.initialize(app).
    //
    _this.publicKey = '';

    //
    // Username suffix stored with registry identifiers, e.g. omskian@saito.
    //
    _this.domain = '@saito';

    //
    // set true for testing locally
    // All it does is allows both main nodes and lite clients to update
    // this.registry_publickey with the public key of the main node
    //
    _this.local_dev = 1;

    //
    // EVENTS
    //
    // Saito Registry module supports two main events, one that fetches identifiers from
    // the DNS service and then updates the DOM, and a second that starts the registration
    // process by showing a popup. The first is the entry point for most applications.
    //
    _this.app.connection.on('registry-fetch-identifiers-and-update-dom', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(keys) {
        var _i, _Object$keys, i, _i2, unidentified_keys;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              //
              // every 1 in 20 times, clear cache of anonymous keys to requery
              //
              if (_this.peers.length && Math.random() < 0.05) {
                for (_i = 0, _Object$keys = Object.keys(_this.cached_keys); _i < _Object$keys.length; _i++) {
                  i = _Object$keys[_i];
                  if (i == _this.cached_keys[i]) {
                    delete _this.cached_keys[i];
                  }
                }
              }
              for (_i2 = 0; _i2 < keys.length; _i2++) {
                if (_this.cached_keys[keys[_i2]]) {
                  _this.app.browser.updateAddressHTML(keys[_i2], _this.cached_keys[keys[_i2]]);
                } else {
                  if (!_this.keys_to_look_up.includes(keys[_i2])) {
                    _this.keys_to_look_up.push(keys[_i2]);
                  }
                }
              }
              if (_this.peers.length) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              unidentified_keys = Array.from(_this.keys_to_look_up);
              _this.keys_to_look_up = [];
              _this.fetchManyIdentifiers(unidentified_keys, function (answer) {
                //
                // This callback is run in the browser
                //
                Object.entries(answer).forEach(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                    key = _ref3[0],
                    value = _ref3[1];
                  if (value !== _this.publicKey) {
                    //
                    // if this is a key that is stored in our keychain, then we want
                    // to update the cached value that we have stored there as well
                    //
                    if (_this.app.keychain.returnKey(key, true) && key !== value) {
                      _this.app.keychain.addKey({
                        publicKey: key,
                        identifier: value
                      });
                    }
                    _this.app.browser.updateAddressHTML(key, value);
                  }
                });
                _this.app.connection.emit('update-username-in-game');

                //
                // save all keys queried to cache so even if we get nothing
                // back we won't query the server again for them.
                //
                for (var _i3 = 0; _i3 < unidentified_keys.length; _i3++) {
                  if (!_this.cached_keys[unidentified_keys[_i3]]) {
                    _this.cached_keys[unidentified_keys[_i3]] = unidentified_keys[_i3];
                  }
                }
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.app.connection.on('register-username-or-login', function (obj) {
      var key = _this.app.keychain.returnKey(_this.publicKey);
      if (key !== null && key !== void 0 && key.has_registered_username) {
        return;
      }
      if (!_this.register_username_overlay) {
        _this.register_username_overlay = new RegisterUsernameOverlay(_this.app, _this);
      }
      if (obj !== null && obj !== void 0 && obj.success_callback) {
        _this.callback = obj.success_callback;
      }
      _this.register_username_overlay.render(obj === null || obj === void 0 ? void 0 : obj.msg);
    });
    if (_this.app.BROWSER) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/saito/lib/adjectives.json', true); //true -> async
      xhr.responseType = 'json'; //only in async
      xhr.send();
      xhr.onload = function () {
        if (xhr.status != 200) {
          console.error('problem loading dictionary!');
        } else {
          _this.wordlist1 = xhr.response;
        }
      };
      var xhr2 = new XMLHttpRequest();
      xhr2.open('GET', '/saito/lib/nouns.json', true); //true -> async
      xhr2.responseType = 'json'; //only in async
      xhr2.send();
      xhr2.onload = function () {
        if (xhr2.status != 200) {
          console.error('problem loading dictionary!');
        } else {
          _this.wordlist2 = xhr2.response;
        }
      };
    }
    return _possibleConstructorReturn(_this, _this);
  }

  //
  // initialization
  //
  _inherits(Registry, _ModTemplate);
  return _createClass(Registry, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _app$options, endpointHost;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(Registry, "initialize", this, 3)([app]);
            case 1:
              if (this.app.BROWSER == 0) {
                endpointHost = ((_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.server) === null || _app$options === void 0 || (_app$options = _app$options.endpoint) === null || _app$options === void 0 ? void 0 : _app$options.host) || '';
                if (endpointHost.includes('localhost') || endpointHost.includes('testnet')) {
                  this.registry_publickey = this.publicKey;
                  console.log('Registry public key: ' + this.registry_publickey);
                }
              } else {
                if (window.location.host.includes('localhost') || window.location.host.includes('testnet')) {
                  this.local_dev = true;
                } else {
                  this.local_dev = false;
                }
              }
              if (!this.app.options.registry) {
                this.app.options.registry = {};
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x2) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }() //
    // let people know we have a registry
    //
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];

      //
      // So all full nodes can act as a registry of sorts
      // (or at leastreroute requests to the actual registry)
      //
      if (this.app.BROWSER == 0) {
        services.push(new PeerService(null, 'registry', 'saito'));
      }
      return services;
    }

    //
    // fetching identifiers
    //
    // this function is run on the browsers, triggered by the event that wants to re-write the DOM
    // so it will query the first peer it sees that runs the registry module and ask it for the
    // identifiers
    //
    // this first checks the cache that browsers maintain in their own memory that maps keys to
    // identifiers and only fetches information from the server when that does not work or find
    // an address. this is intended to limit the load on the parent server.
    //
  }, {
    key: "fetchManyIdentifiers",
    value: function fetchManyIdentifiers() {
      var _this2 = this;
      var publickeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var registry_self = this;
      if (mycallback == null) {
        return;
      }
      var found_keys = {};
      var missing_keys = [];
      publickeys.forEach(function (publickey) {
        var identifier = _this2.app.keychain.returnIdentifierByPublicKey(publickey);

        //returns "" if not found
        if (identifier) {
          found_keys[publickey] = identifier;
        } else {
          missing_keys.push(publickey);
        }
      });
      if (missing_keys.length == 0) {
        mycallback(found_keys);
        return 1;
      }
      if (this.publicKey == this.registry_publickey) {
        this.fetchIdentifiersFromDatabase(missing_keys, function (identifiers) {
          for (var key in identifiers) {
            registry_self.cached_keys[key] = identifiers[key];
            found_keys[key] = identifiers[key];
          }
          mycallback(found_keys);
        });
      } else {
        for (var i = 0; i < this.peers.length; i++) {
          this.queryKeys(this.peers[i], missing_keys, function (identifiers) {
            //
            // This callback is executed in the browser
            //
            for (var key in identifiers) {
              registry_self.cached_keys[key] = identifiers[key];
              found_keys[key] = identifiers[key];
            }
            mycallback(found_keys);
          });
        }
      }
    }
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this3 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var registry_self = this;
      if (type == 'saito-return-key') {
        return {
          returnKey: function returnKey() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            //
            // data might be a publickey, permit flexibility
            // in how this is called by pushing it into a
            // suitable object for searching
            //
            if (typeof data === 'string') {
              var d = {
                publicKey: ''
              };
              d.publicKey = data;
              data = d;
            }

            //
            // if keys exist
            //
            for (var key in registry_self.cached_keys) {
              var _data, _data2;
              if (key === ((_data = data) === null || _data === void 0 ? void 0 : _data.publicKey)) {
                if (registry_self.cached_keys[key] && key !== registry_self.cached_keys[key]) {
                  return {
                    publicKey: key,
                    identifier: registry_self.cached_keys[key]
                  };
                } else {
                  return {
                    publicKey: key
                  };
                }
              } else if (registry_self.cached_keys[key] === ((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.identifier)) {
                return {
                  publicKey: key,
                  identifier: registry_self.cached_keys[key]
                };
              }
            }
            return null;
          },
          returnKeys: function returnKeys() {
            keyList = [];
            for (var key in registry_self.cached_keys) {
              keyList.push({
                publicKey: key,
                identifier: registry_self.cached_keys[key]
              });
            }
            return keyList;
          }
        };
      }
      if (type == 'saito-translate-anonymous') {
        return {
          translate: function translate(publicKey) {
            var _this3$app$options;
            if (!((_this3$app$options = _this3.app.options) !== null && _this3$app$options !== void 0 && (_this3$app$options = _this3$app$options.registry) !== null && _this3$app$options !== void 0 && _this3$app$options.override_names)) {
              return null;
            }

            // Convert public key into base16 number
            var pk = _this3.app.crypto.fromBase58(publicKey);

            //Extract first and last 5 digits
            var p1 = pk.slice(-6, -5);
            var n1 = pk.slice(-5, -3);
            var n2 = pk.slice(-3);

            // Map into a number space of about 2000 & 4000
            var f1 = 1 + parseInt(p1, 16) % 8;
            var num1 = f1 * parseInt(n1, 16);
            var num2 = parseInt(n2, 16);

            // Look up 2 words from Scrabble dictionary
            return "<span class='saito-anon'>\"".concat(_this3.wordlist1[num1], " ").concat(_this3.wordlist2[num2], "\"</span><i class=\"fa-solid fa-user-secret\"></i>");
          }
        };
      }
      return _superPropGet(Registry, "respondTo", this, 3)([type]);
    }

    //
    // Creates and sends an on-chain tx to register the identifier @ the domain
    // The complete identifier, including its domain, is limited to 51 characters.
    //
  }, {
    key: "tryRegisterIdentifier",
    value: function () {
      var _tryRegisterIdentifier = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(identifier) {
        var domain,
          newtx,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              domain = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : this.domain;
              if (identifier instanceof String) identifier = identifier.toString();
              if (!(typeof identifier !== 'string')) {
                _context3.n = 1;
                break;
              }
              throw TypeError('identifier must be a string');
            case 1:
              identifier += domain;
              if (!(identifier.length > 51)) {
                _context3.n = 2;
                break;
              }
              throw Error('Identifier must be 51 characters or fewer, including the domain');
            case 2:
              if (/^[0-9A-Za-z]+@[^@]+$/.test(identifier)) {
                _context3.n = 3;
                break;
              }
              throw Error('Alphanumeric Characters only');
            case 3:
              _context3.n = 4;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.registry_publickey);
            case 4:
              newtx = _context3.v;
              if (newtx) {
                _context3.n = 5;
                break;
              }
              throw Error('NULL TX CREATED IN REGISTRY MODULE');
            case 5:
              newtx.msg.module = 'Registry';
              newtx.msg.request = 'register';
              newtx.msg.identifier = identifier;
              _context3.n = 6;
              return newtx.sign();
            case 6:
              _context3.n = 7;
              return this.app.network.propagateTransaction(newtx);
            case 7:
              return _context3.a(2, true);
          }
        }, _callee3, this);
      }));
      function tryRegisterIdentifier(_x3) {
        return _tryRegisterIdentifier.apply(this, arguments);
      }
      return tryRegisterIdentifier;
    }() //
    // A finished registry username is a name plus this.domain, e.g. omskian@saito.
    // Partial input such as "omskian@sai" is not a lookup.
    //
  }, {
    key: "identifierUsesKnownDomain",
    value: function identifierUsesKnownDomain(identifier) {
      return typeof identifier === 'string' && Boolean(this.domain) && identifier.endsWith(this.domain) && identifier.split('@').length === 2;
    }
  }, {
    key: "isRegistryIdentifier",
    value: function isRegistryIdentifier(identifier) {
      if (typeof identifier !== 'string' || !this.domain || !identifier.endsWith(this.domain)) {
        return false;
      }
      var name = identifier.slice(0, -this.domain.length);
      return /^[0-9A-Za-z]+$/.test(name) && identifier.length <= 51;
    }

    //
    // Local keychain first, then one registry namecheck for a finished username.
    // Returns a Saito public key, or null.
    //
  }, {
    key: "resolveIdentifier",
    value: function () {
      var _resolveIdentifier = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(identifier) {
        var _this$app$keychain,
          _this$app$keychain$re,
          _this$peers$,
          _this4 = this,
          _this$app$keychain2,
          _this$app$keychain2$a;
        var local, peer, rows, row;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (this.isRegistryIdentifier(identifier)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, null);
            case 1:
              local = (_this$app$keychain = this.app.keychain) === null || _this$app$keychain === void 0 || (_this$app$keychain$re = _this$app$keychain.returnPublicKeyByIdentifier) === null || _this$app$keychain$re === void 0 ? void 0 : _this$app$keychain$re.call(_this$app$keychain, identifier);
              if (!(local && this.app.crypto.isPublicKey(local))) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, local);
            case 2:
              peer = (_this$peers$ = this.peers[0]) === null || _this$peers$ === void 0 ? void 0 : _this$peers$.publicKey;
              if (peer) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2, null);
            case 3:
              _context4.n = 4;
              return new Promise(function (resolve) {
                var settled = false;
                var finish = function finish(value) {
                  if (settled) {
                    return;
                  }
                  settled = true;
                  resolve(Array.isArray(value) ? value : []);
                };
                try {
                  _this4.app.network.sendRequestAsTransaction('registry query', {
                    request: 'registry namecheck',
                    identifier: identifier
                  }, function (res) {
                    return finish(res);
                  }, peer);
                } catch (err) {
                  finish([]);
                }
                setTimeout(function () {
                  return finish([]);
                }, 8000);
              });
            case 4:
              rows = _context4.v;
              row = rows.find(function (entry) {
                return (entry === null || entry === void 0 ? void 0 : entry.identifier) === identifier && _this4.app.crypto.isPublicKey(entry.publickey);
              });
              if (row) {
                _context4.n = 5;
                break;
              }
              return _context4.a(2, null);
            case 5:
              (_this$app$keychain2 = this.app.keychain) === null || _this$app$keychain2 === void 0 || (_this$app$keychain2$a = _this$app$keychain2.addKey) === null || _this$app$keychain2$a === void 0 || _this$app$keychain2$a.call(_this$app$keychain2, row.publickey, {
                identifier: identifier
              });
              return _context4.a(2, row.publickey);
          }
        }, _callee4, this);
      }));
      function resolveIdentifier(_x4) {
        return _resolveIdentifier.apply(this, arguments);
      }
      return resolveIdentifier;
    }()
    /**
     * QueryKeys is a cross network database search for a set of public keys
     * Typically we call it from the browser on the first peer claiming to have a registry service
     */
  }, {
    key: "queryKeys",
    value: function queryKeys(peer, keys, mycallback) {
      if (peer == undefined) {
        console.error('Attempting to query keys from undefined peer');
        console.log('Available Registry service peers:', this.peers);
        if (mycallback) {
          mycallback({});
        }
        return;
      }
      var data = {
        request: 'registry query',
        keys: keys
      };

      //console.log(`REGISTRY queryKeys from ${this.publicKey} to ${peer.publicKey}`);
      return this.app.network.sendRequestAsTransaction('registry query', data, mycallback ? function (identifiers) {
        return mycallback(Object.fromEntries(Object.entries(identifiers || {}).map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            identifier = _ref5[1];
          return [key, typeof identifier === 'string' && identifier !== key ? identifier.slice(0, 51) : identifier];
        })));
      } : mycallback, peer.publicKey);
    }
  }, {
    key: "onPeerServiceUp",
    value: function onPeerServiceUp(app, peer) {
      var _this5 = this;
      var service = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (service.service === 'registry') {
        var _app$wallet;
        var should_push = true;
        for (var i = 0; i < this.peers.length; i++) {
          if (this.peers[i].publicKey == peer.publicKey) {
            // refresh / overwrite reference to peer
            this.peers[i] = peer;
            should_push = false;
          }
        }
        if (should_push) {
          this.peers.push(peer);
        }

        //
        // We want to allow service nodes to connect to each other as registry peers
        // but don't need to do any of the other processing
        //
        if (!app.BROWSER) {
          return;
        }
        console.log('============== REGISTRY connected ==============');

        //
        // if we have instructed the server to run this application locally then we
        // want browsers (connecting to the server) to update their registry publickey
        // so the publickey of the server.
        //

        if (this.local_dev) {
          this.registry_publickey = peer.publicKey;
        }
        var myKey = app.keychain.returnKey(this.publicKey, true);
        var walletKey = String(((_app$wallet = app.wallet) === null || _app$wallet === void 0 ? void 0 : _app$wallet.publicKey) || '').trim();
        var alreadyInWallet = Boolean(walletKey) && walletKey === String(this.publicKey || '').trim();
        if (!alreadyInWallet && myKey !== null && myKey !== void 0 && myKey.identifier && this.identifierUsesKnownDomain(myKey.identifier)) {
          var registry_self = this;
          this.queryKeys(peer, [this.publicKey], function (identifiers) {
            for (var key in identifiers) {
              if (key == myKey.publicKey) {
                if (identifiers[key] !== myKey.identifier) {
                  console.log('REGISTRY: Identifier mismatch...');
                  console.log("REGISTRY: Expecting ".concat(myKey.identifier, ", but Registry has ").concat(identifiers[key]));
                }
                return;
              }
            }
            var name = myKey.identifier.slice(0, -registry_self.domain.length);
            registry_self.tryRegisterIdentifier(name, registry_self.domain);
            console.log('REGISTRY: Attempting to register our name again');
          });
        } else if (!(myKey !== null && myKey !== void 0 && myKey.identifier) && myKey !== null && myKey !== void 0 && myKey.has_registered_username) {
          console.log('REGISTRY: unset registering... status');
          this.app.keychain.addKey(this.publicKey, {
            has_registered_username: false
          });
          this.app.connection.emit('registry-update-identifier', this.publicKey);
        }

        // Bulk get cached keys
        var msg = {
          request: 'cached keys'
        };
        this.app.network.sendRequestAsTransaction('registry', msg, function (keys) {
          console.debug('Synching cached keys with peer: ', keys);
          for (var key in keys) {
            if (!_this5.cached_keys[key] || key == _this5.cached_keys[key]) {
              _this5.cached_keys[key] = keys[key];
              _this5.app.browser.updateAddressHTML(key, keys[key]);
            }
          }
          // Try again know that we have cached and looked up the keys...
          _this5.app.connection.emit('registry-fetch-identifiers-and-update-dom', _this5.keys_to_look_up);
        }, peer.publicKey);
      }
    }

    /////////////////////////////
    // HANDLE PEER TRANSACTION //
    /////////////////////////////
    //
    // data queries hit here
    //
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app) {
        var newtx,
          peer,
          mycallback,
          txmsg,
          _txmsg$data,
          keys,
          _txmsg$data2,
          identifier,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              newtx = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : null;
              peer = _args5.length > 2 ? _args5[2] : undefined;
              mycallback = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : null;
              if (!(newtx == null)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, 0);
            case 1:
              txmsg = newtx.returnMessage();
              if (txmsg !== null && txmsg !== void 0 && txmsg.data) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, 0);
            case 2:
              if (!(txmsg.request == 'registry query')) {
                _context5.n = 4;
                break;
              }
              if (!(txmsg.data.request === 'registry query')) {
                _context5.n = 3;
                break;
              }
              keys = (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.keys; //console.log("REGISTRY query lookup: ", keys);
              return _context5.a(2, this.fetchIdentifiersFromDatabase(keys, mycallback));
            case 3:
              if (!(txmsg.data.request === 'registry namecheck')) {
                _context5.n = 4;
                break;
              }
              identifier = (_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.identifier; //console.log("REGISTRY check if identifer is registered: ", identifier);
              return _context5.a(2, this.checkIdentifierInDatabase(identifier, mycallback));
            case 4:
              if (txmsg.request == 'registry') {
                if (txmsg.data.request === 'cached keys') {
                  if (mycallback) {
                    mycallback(this.cached_keys);
                  }
                }
              }
              return _context5.a(2, _superPropGet(Registry, "handlePeerTransaction", this, 3)([app, newtx, peer, mycallback]));
          }
        }, _callee5, this);
      }));
      function handlePeerTransaction(_x5) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }() //
    // There are TWO types of requests that this module will process on-chain. The first is
    // the request to REGISTER an address on this.domain. This will only be processed by the node that
    // is running the publickey identified in this module as the "registry_publickey".
    //
    // The second is a confirmation that the node running the domain broadcasts into the network
    // with a proof-of-registration. All nodes that run the DNS service should listen for
    // these messages and add the records into their own copy of the database, along with the
    // signed proof-of-registration.
    //
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(blk, tx, conf) {
        var txmsg, identifier, publickey, unixtime, bid, bsh, lock_block, signed_message, sig, signer, lc, res, fee, newtx, _publickey, _identifier, _signed_message, _sig, _bid, _bsh, _unixtime, _lock_block, _signer, _lc, _res, _t, _t2, _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              txmsg = tx.returnMessage();
              if (!(Number(conf) == 0)) {
                _context6.n = 13;
                break;
              }
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.module) === 'Registry')) {
                _context6.n = 7;
                break;
              }
              if (!(typeof txmsg.identifier !== 'string' || txmsg.identifier.length > 51 || !/^[0-9A-Za-z]+@[^@]+$/.test(txmsg.identifier))) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              console.log("REGISTRY: ".concat(tx.from[0].publicKey, " -> ").concat(txmsg.identifier));

              /////////////////////////////////////////
              // REGISTRATION REQUESTS - main server //
              /////////////////////////////////////////
              if (!(tx.isTo(this.publicKey) && this.publicKey === this.registry_publickey)) {
                _context6.n = 7;
                break;
              }
              console.log('I AM THE REGISTERING MACHINE!');
              identifier = txmsg.identifier;
              publickey = tx.from[0].publicKey;
              unixtime = new Date().getTime();
              bid = blk.id;
              bsh = blk.hash;
              lock_block = 0;
              signed_message = identifier + publickey + bid + bsh;
              _t = this.app.crypto;
              _t2 = signed_message;
              _context6.n = 2;
              return this.app.wallet.getPrivateKey();
            case 2:
              sig = _t.signMessage.call(_t, _t2, _context6.v);
              //this.app.wallet.signMessage(signed_message);
              signer = this.registry_publickey;
              lc = 1; // servers update database
              _context6.n = 3;
              return this.addRecord(identifier, publickey, unixtime, bid, bsh, lock_block, sig, signer, 1);
            case 3:
              res = _context6.v;
              fee = BigInt(0); //tx.returnPaymentTo(this.publicKey);
              _context6.n = 4;
              return this.app.wallet.createUnsignedTransaction(tx.from[0].publicKey, BigInt(0), fee);
            case 4:
              newtx = _context6.v;
              // send message
              if (res == 1) {
                newtx.msg.module = 'Email';
                newtx.msg.origin = 'Registry';
                newtx.msg.title = 'Address Registration Success!';
                newtx.msg.identifier = identifier;
                newtx.msg.publickey = publickey;
                newtx.msg.unixtime = unixtime;
                newtx.msg.bid = bid;
                newtx.msg.bsh = bsh;
                newtx.msg.lock_block = lock_block;
                newtx.msg.bsh = unixtime;
                newtx.msg.signer = signer;
                newtx.msg.signed_message = signed_message;
                newtx.msg.signature = sig;
              } else {
                newtx.msg.module = 'Email';
                newtx.msg.title = 'Address Registration Failed!';
                newtx.msg.identifier = identifier;
                newtx.msg.publickey = publickey;
                newtx.msg.unixtime = unixtime;
                newtx.msg.bid = bid;
                newtx.msg.bsh = bsh;
                newtx.msg.lock_block = lock_block;
                newtx.msg.bsh = unixtime;
                newtx.msg.signer = signer;
                newtx.msg.signed_message = '';
                newtx.msg.signature = '';
              }
              console.log('REGISTRY signing transaction...');
              _context6.n = 5;
              return newtx.sign();
            case 5:
              console.log('REGISTRY propagating transaction...');
              _context6.n = 6;
              return this.app.network.propagateTransaction(newtx);
            case 6:
              console.log('REGISTRY done propagating transaction...');
              return _context6.a(2);
            case 7:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.module) == 'Email')) {
                _context6.n = 13;
                break;
              }
              console.log('REGISTRY EMAIL: ' + txmsg.title, 'to: ', tx.to[0].publicKey);
              console.log(tx);
              if (!(tx.from[0].publicKey == this.registry_publickey)) {
                _context6.n = 13;
                break;
              }
              console.log('FROM THE REGISTRAR!');
              _context6.p = 8;
              //
              // am email? for us? from the DNS registrar?
              //
              _publickey = tx.to[0].publicKey;
              _identifier = tx.msg.identifier;
              _signed_message = tx.msg.signed_message;
              _sig = tx.msg.signature;
              _bid = tx.msg.bid;
              _bsh = tx.msg.bsh;
              _unixtime = tx.msg.unixtime;
              _lock_block = tx.msg.lock_block;
              _signer = tx.msg.signer;
              _lc = 1;
              if (!this.app.crypto.verifyMessage(_signed_message, _sig, this.registry_publickey)) {
                _context6.n = 11;
                break;
              }
              if (!(this.publicKey != this.registry_publickey)) {
                _context6.n = 11;
                break;
              }
              if (this.app.BROWSER) {
                _context6.n = 10;
                break;
              }
              _context6.n = 9;
              return this.addRecord(_identifier, _publickey, _unixtime, _bid, _bsh, _lock_block, _sig, _signer, 1);
            case 9:
              _res = _context6.v;
            case 10:
              if (tx.isTo(this.publicKey)) {
                this.app.keychain.addKey(tx.to[0].publicKey, {
                  identifier: _identifier,
                  watched: true,
                  block_id: blk.id,
                  block_hash: blk.hash,
                  lc: 1
                });
                console.info('***********************');
                console.info('verification success for : ' + _identifier);
                console.info('***********************');
                this.app.browser.updateAddressHTML(tx.to[0].publicKey, _identifier);
                this.app.connection.emit('registry-update-identifier', tx.to[0].publicKey);
                if (this.callback) {
                  this.callback(_identifier);
                }
              }
            case 11:
              _context6.n = 13;
              break;
            case 12:
              _context6.p = 12;
              _t3 = _context6.v;
              console.error('ERROR verifying username registration message: ', _t3);
            case 13:
              return _context6.a(2);
          }
        }, _callee6, this, [[8, 12]]);
      }));
      function onConfirmation(_x6, _x7, _x8) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
    /*
     * Lightly recursive, server side code to look up keys in the registry database
     * Invoked through a peer request.
     * Any requested keys not found are passed on to any peers with the DNS publickey
     */
  }, {
    key: "fetchIdentifiersFromDatabase",
    value: function () {
      var _fetchIdentifiersFromDatabase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(keys) {
        var mycallback,
          registry_self,
          found_keys,
          missing_keys,
          myregexp,
          i,
          where_statement,
          sql,
          rows,
          _i4,
          identifier,
          found_check,
          _iterator,
          _step,
          key,
          has_peer,
          _i5,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              mycallback = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
              registry_self = this;
              found_keys = {};
              missing_keys = [];
              myregexp = new RegExp('^([a-zA-Z0-9])*$');
              i = keys.length - 1;
            case 1:
              if (!(i >= 0)) {
                _context7.n = 3;
                break;
              }
              if (myregexp.test(keys[i])) {
                _context7.n = 2;
                break;
              }
              keys.splice(i, 1);
              return _context7.a(3, 2);
            case 2:
              i--;
              _context7.n = 1;
              break;
            case 3:
              if (!(keys.length > 0)) {
                _context7.n = 5;
                break;
              }
              where_statement = "publickey in (\"".concat(keys.join('","'), "\")");
              sql = "SELECT * \n                   FROM records\n                   WHERE ".concat(where_statement);
              _context7.n = 4;
              return this.app.storage.queryDatabase(sql, {}, 'registry');
            case 4:
              rows = _context7.v;
              if ((rows === null || rows === void 0 ? void 0 : rows.length) > 0) {
                for (_i4 = 0; _i4 < rows.length; _i4++) {
                  // Bound lookup results without rewriting signed records.
                  identifier = typeof rows[_i4].identifier === 'string' ? rows[_i4].identifier.slice(0, 51) : rows[_i4].identifier;
                  found_keys[rows[_i4].publickey] = identifier;
                  registry_self.cached_keys[rows[_i4].publickey] = identifier;
                }
              }
            case 5:
              //
              // which keys are we missing ?
              //
              found_check = Object.keys(found_keys);
              _iterator = _createForOfIteratorHelper(keys);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  key = _step.value;
                  if (!found_check.includes(key)) {
                    missing_keys.push(key);
                  }
                }

                //console.log("this REGISTRY found", found_keys, "but not", missing_keys);

                //
                // Fallback because browsers don't automatically have DNS as a peer
                //
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              if (!(missing_keys.length > 0 && this.publicKey !== this.registry_publickey)) {
                _context7.n = 9;
                break;
              }
              has_peer = false; //
              // if we were asked about any missing keys, ask our parent server
              //
              _i5 = 0;
            case 6:
              if (!(_i5 < this.peers.length)) {
                _context7.n = 8;
                break;
              }
              if (!(this.peers[_i5].publicKey == this.registry_publickey)) {
                _context7.n = 7;
                break;
              }
              has_peer = true;
              // ask the parent for the missing values, cache results
              return _context7.a(2, this.queryKeys(this.peers[_i5], missing_keys, function (res) {
                //
                // This is run by the main service node
                //
                for (var key in res) {
                  if (res[key] !== key) {
                    var _identifier2 = typeof res[key] === 'string' ? res[key].slice(0, 51) : res[key];
                    registry_self.cached_keys[key] = _identifier2;
                    found_keys[key] = _identifier2;
                  }
                }
                if (mycallback) {
                  //console.log("REGISTRY: run nested DB callback on found keys", found_keys);
                  mycallback(found_keys);
                  return 1;
                }
              }));
            case 7:
              _i5++;
              _context7.n = 6;
              break;
            case 8:
              if (!has_peer) {
                console.log('REGISTRY: Not a peer with the central DNS');
                //
                // Run callback to prevent us from spamming this node
                // with repeated requests of the same damn keys
                //
                mycallback(found_keys);
              }

              //No peer found...
              return _context7.a(2, 0);
            case 9:
              if (!mycallback) {
                _context7.n = 10;
                break;
              }
              //
              // This is run by either the main service node or the proper registry node
              //
              //console.log("REGISTRY: run DB callback on found keys", found_keys);
              mycallback(found_keys);
              return _context7.a(2, found_check.length > 0);
            case 10:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function fetchIdentifiersFromDatabase(_x9) {
        return _fetchIdentifiersFromDatabase.apply(this, arguments);
      }
      return fetchIdentifiersFromDatabase;
    }()
  }, {
    key: "checkIdentifierInDatabase",
    value: function () {
      var _checkIdentifierInDatabase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(identifier) {
        var _this6 = this;
        var mycallback,
          sql,
          rows,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              mycallback = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : null;
              if (mycallback) {
                _context8.n = 1;
                break;
              }
              console.warn('No callback');
              return _context8.a(2, 0);
            case 1:
              if (!(this.publicKey == this.registry_publickey)) {
                _context8.n = 3;
                break;
              }
              sql = "SELECT * FROM records WHERE identifier = ?";
              _context8.n = 2;
              return this.app.storage.queryDatabase(sql, [identifier], 'registry');
            case 2:
              rows = _context8.v;
              mycallback(rows);
              return _context8.a(2, 1);
            case 3:
              _context8.n = 4;
              return this.sendPeerDatabaseRequestWithFilter('Registry', "SELECT * FROM records WHERE identifier = \"".concat(identifier, "\""), function (res) {
                mycallback(res === null || res === void 0 ? void 0 : res.rows);
                return 1;
              }, function (p) {
                if (p.publicKey == _this6.registry_publickey) {
                  return 1;
                }
                return 0;
              });
            case 4:
              return _context8.a(2, 0);
          }
        }, _callee8, this);
      }));
      function checkIdentifierInDatabase(_x0) {
        return _checkIdentifierInDatabase.apply(this, arguments);
      }
      return checkIdentifierInDatabase;
    }()
  }, {
    key: "addRecord",
    value: function () {
      var _addRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var identifier,
          publickey,
          unixtime,
          bid,
          bsh,
          lock_block,
          sig,
          signer,
          lc,
          sql,
          params,
          res,
          _args9 = arguments;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              identifier = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : '';
              publickey = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : '';
              unixtime = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : 0;
              bid = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : 0;
              bsh = _args9.length > 4 && _args9[4] !== undefined ? _args9[4] : '';
              lock_block = _args9.length > 5 && _args9[5] !== undefined ? _args9[5] : 0;
              sig = _args9.length > 6 && _args9[6] !== undefined ? _args9[6] : '';
              signer = _args9.length > 7 && _args9[7] !== undefined ? _args9[7] : '';
              lc = _args9.length > 8 && _args9[8] !== undefined ? _args9[8] : 1;
              sql = "INSERT OR IGNORE INTO records (identifier,\n                                    publickey,\n                                    unixtime,\n                                    bid,\n                                    bsh,\n                                    lock_block,\n                                    sig,\n                                    signer,\n                                    lc)\n               VALUES ($identifier,\n                       $publickey,\n                       $unixtime,\n                       $bid,\n                       $bsh,\n                       $lock_block,\n                       $sig,\n                       $signer,\n                       $lc)";
              params = {
                $identifier: identifier,
                $publickey: publickey,
                $unixtime: unixtime,
                $bid: Number(bid),
                $bsh: bsh,
                $lock_block: lock_block,
                $sig: sig,
                $signer: signer,
                $lc: lc
              };
              _context9.n = 1;
              return this.app.storage.runDatabase(sql, params, 'registry');
            case 1:
              res = _context9.v;
              return _context9.a(2, res === null || res === void 0 ? void 0 : res.changes);
          }
        }, _callee9, this);
      }));
      function addRecord() {
        return _addRecord.apply(this, arguments);
      }
      return addRecord;
    }()
  }, {
    key: "onChainReorganization",
    value: function () {
      var _onChainReorganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(bid, bsh, lc) {
        var sql, params;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              sql = 'UPDATE records SET lc = $lc WHERE bid = $bid AND bsh = $bsh';
              params = {
                $bid: Number(bid),
                $bsh: String(bsh || ''),
                $lc: lc ? 1 : 0
              };
              _context0.n = 1;
              return this.app.storage.runDatabase(sql, params, 'registry');
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function onChainReorganization(_x1, _x10, _x11) {
        return _onChainReorganization.apply(this, arguments);
      }
      return onChainReorganization;
    }()
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      if (modname == this.name) {
        return 1;
      }
      if (modname == 'Email') {
        return 1;
      }
      return 0;
    }
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings(container) {
      var as = new AppSettings(this.app, this, container);
      as.render();
    }
  }]);
}(ModTemplate);
module.exports = Registry;